import { LocationTypes } from '../constants';

const convertGeonameToAutocompleteItem = (geoname) => ({
  featureClass: geoname.featureClass,
  city: geoname.city,
  value: geoname.id,
  airportCode: geoname.iata,
  label: `${geoname.name}${geoname.iata ? ` (${geoname.iata})` : ''}`,
  locationType: geoname.iata ? LocationTypes.AIRPORT : null,
});

export default convertGeonameToAutocompleteItem;
